import {
    GetAllTicketsActionType,
    GetAllTicketsAction,
    SaveTicketAction,
    SaveTicketActionType
} from '../actions/dateTickets';
import dateTicket from '../models/dateTicket';
import { Map } from 'immutable';

export const initialState = Map<string, dateTicket>();

export type dateTicketsState = typeof initialState;

export default (state = initialState, action: GetAllTicketsActionType | SaveTicketActionType) => {
    switch (action.type) {
        case GetAllTicketsAction:
            return state.concat(action.tickets);
        case SaveTicketAction:
            return state.set(action.ticket.id, action.ticket);
        default:
            return state;
    }
};
